import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appServices } from '@/data/AppServices';

export function SentenceListPage() {
  const [queue, setQueue] = useState({ newCount: 0, reviewCount: 0, totalCount: 0 });
  const navigate = useNavigate();

  const reload = useCallback(async () => {
    setQueue(await appServices.sentences.todayQueue());
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const empty = queue.newCount === 0 && queue.reviewCount === 0;

  return (
    <div className="page stack">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <strong>例句练习</strong>
        <button type="button" className="secondary" onClick={() => navigate('/scenario')}>
          返回对练
        </button>
      </div>
      {empty ? (
        <div className="muted">今天没有到期例句。可以先去情景对练，或等内置语料完成后再来。</div>
      ) : (
        <section className="card">
          <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div>待复习 {queue.reviewCount}</div>
              <div className="muted">新例句 {queue.newCount}</div>
            </div>
            <button type="button" onClick={() => navigate('/scenario/sentences/practice')}>
              开始练习
            </button>
          </div>
        </section>
      )}
    </div>
  );
}
